export const PATHS = {
    /**
     *
     * Path schema for campaigns
     * Remember to use this format for new campaigns:
     * /campaign-name/landing
     * /campaign-name/checkout
     * /campaign-name/success
     *
     * This is so that we can predict the success page etc in places where we need to redirect the user
     *
     * Also remember that these are tracked in analytics, so changing them might require changes in tracking systems
     **/

    dashboard: '/',
    download: '/download',

    // Payment Error page
    paymentFailed: '/payment-failed',

    plans: '/plans',

    // subscribe
    subscribe: '/subscribe',
    subscribeCheckout: '/subscribe/checkout',
    subscribeWelcome: '/subscribe/welcome',
    // this is redundant but needed so that we get a predictable success address
    subscribeSuccess: '/subscribe/success',

    purchase: '/purchase',

    // upgrade sub
    upgrade: '/subscription/upgrade',
    upgradeCheckout: '/subscription/upgrade/checkout',
    upgraded: '/subscription/upgraded',

    // canceling subscription
    subscriptionCancel: '/subscription/cancel',
    subscriptionCanceled: '/subscription/canceled',

    // family plans
    addFamilyMember: '/family/add',

    // winback
    winback: '/start-now',
    winbackCheckout: '/start-now/checkout',
    winbackSuccess: '/start-now/success',

    // free trial offer
    // in this campaign we offer 30 days of trial instead of one week (during COVID-19 we increased it from 2 weeks to 30 days)
    // See https://yousician.atlassian.net/wiki/spaces/YS/pages/1270973077/
    freeTrialOffer: '/free-trial-offer',
    freeTrialOfferSuccess: '/free-trial-offer-success',
    // this is redundant but needed so that we get a predictable success address
    freeTrialOfferSuccessNormalized: '/free-trial-offer/success',

    // free trial offer, just like "free trial offer" but with 7 days of free trial instead of 30
    freeTrialOffer7: '/free-trial-offer-7',
    freeTrialOffer7Success: '/free-trial-offer-7-success',
    // this is redundant but needed so that we get a predictable success address
    freeTrialOffer7SuccessNormalized: '/free-trial-offer-7/success',

    // free trial offer, just like "free trial offer" but with 14 days of free trial instead of 30
    freeTrialOffer14: '/free-trial-offer-14',
    freeTrialOffer14Success: '/free-trial-offer-14-success',
    // this is redundant but needed so that we get a predictable success address
    freeTrialOffer14SuccessNormalized: '/free-trial-offer-14/success',

    // Black Friday!
    blackFriday: '/black-friday',
    blackFridayOver: '/black-friday/over',
    blackFridayCheckout: '/black-friday/checkout',
    blackFridaySuccess: '/black-friday/success',

    // Winback 2021 campaign (COVID-19 Limited Edititon)
    aprilDiscount: '/april-discount',
    aprilDiscountCheckout: '/april-discount/checkout',
    aprilDiscountSuccess: '/april-discount/success',

    // Partnership campaign with Jason Mraz!
    partnershipJason: '/jasonmraz',
    partnershipJasonCheckout: '/jasonmraz/checkout',
    partnershipJasonSuccess: '/jasonmraz/success',
    partnershipJasonOver: '/jasonmraz/over',

    // Yousician25
    yousician25: '/yousician-25',
    yousician25Over: '/yousician-25/over',
    yousician25Checkout: '/yousician-25/checkout',
    yousician25Success: '/yousician-25/success',

    // Premium Offer
    premiumOffer: '/premium-offer',
    premiumOfferOver: '/premium-offer/over',
    premiumOfferCheckout: '/premium-offer/checkout',
    premiumOfferSuccess: '/premium-offer/success',

    // Premium plus Offer
    premiumPlusOffer: '/premium-plus-offer',
    premiumPlusOfferCheckout: '/premium-plus-offer/checkout',
    premiumPlusOfferSuccess: '/premium-plus-offer/success',

    // World Music Day
    worldMusicDay: '/world-music-day',
    worldMusicDayOver: '/world-music-day/over',
    worldMusicDayCheckout: '/world-music-day/checkout',
    worldMusicDaySuccess: '/world-music-day/success',
    noAccessWorldMusicDay: '/no-access/world-music-day',

    // New Year
    newYear: '/new-year',
    newYearOver: '/new-year/over',
    newYearCheckout: '/new-year/checkout',
    newYearSuccess: '/new-year/success',

    // Back to School
    backToSchool: '/back-to-school',
    backToSchoolOver: '/back-to-school/over',
    backToSchoolCheckout: '/back-to-school/checkout',
    backToSchoolSuccess: '/back-to-school/success',

    // savusauna
    trials: '/start-trial/:token',
    trialsCheckout: '/start-trial/:token/checkout',
    trialsSuccess: '/start-trial/success',

    // resubscription
    resubscribe: '/subscription/resubscribe',
    resubscribeCheckout: '/subscription/resubscribe/checkout',
    resubscribeSuccess: '/subscription/resubscribed',

    // privacy
    privacyDownload: '/privacy/download',
    privacyDelete: '/privacy/delete',
    privacyDeleteConfirm: '/privacy/delete/confirm',
    privacyNotice: '/privacy-notice',

    selectInstrument: '/select-instrument',

    // gifting
    gift: '/gift',
    giftCustomize: '/gift/customize',
    giftCheckout: '/gift/checkout',
    giftSuccess: '/gift/success',
    giftRedeem: '/gift/redeem',
    giftRedeemSuccess: '/gift/redeem/success',

    // from app - redirects + processing
    fromApp: {
        freeTrial: '/from-app/freetrial',
        purchaseSubscription: '/from-app/purchasesubscription',
        externalService: '/from-app/external-service',
        facebookLogin: '/facebook-login',
    },

    processAppleSignIn: '/process-apple-signin',

    // redeem coupons
    redeem: '/redeem',

    // no access
    noAccess: '/no-access',
    noAccessSubscribe: '/no-access/subscribe',
    noAccessUpgrade: '/no-access/upgrade',
    noAccessResubscribe: '/no-access/resubscribe',
    noAccessCancel: '/no-access/cancel',
    noAccessGifting: '/no-access/gift',
    noAccessWinback: '/no-access/start-now',
    noAccessTrials: '/no-access/start-trial',
    noAccessBlackFriday: '/no-access/black-friday',
    noAccessAprilDiscount: '/no-access/april-discount',
    noAccessPartnership: '/no-access/partnership-jason',
    noAccessFreeTrialOffer: '/no-access/free-trial-offer',
    noAccessPremiumOffer: '/no-access/premium-offer',
    noAccessYousician25: '/no-access/yousician-25',

    // auth
    login: '/login',
    register: '/register',
    access: '/access',
    forgotPassword: '/forgot-password',
    resetPassword: '/reset-password',
    confirmEmail: '/confirmemail',
    tokenAuth: '/tokenauth',

    // other
    paypalProcess: '/paypal-process',
};
